import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _reduce from "lodash/reduce";

var _YodleeAccountTypeMap, _YodleeAccountSubType, _DefaultTopProviders, _genericIconsByYodlee;

export var ProviderAccountState = {
  LOGIN_IN_PROGRESS: 'LOGIN_IN_PROGRESS',
  MFA_REQUIRED: 'MFA_REQUIRED',
  MFA_IN_PROGRESS: 'MFA_IN_PROGRESS',
  AUTHENTICATED: 'AUTHENTICATED',
  ERROR: 'ERROR',
  ACTIVE: 'ACTIVE'
};
export var DEFAULT_PROVIDER_SEARCH_DEBOUNCE = 300;
export var PROVIDER_STATUS_POLLING_INTERVAL = 4000;
export var ProviderType = {
  BANKING: 'BANKING',
  CREDIT_CARDS: 'CREDIT_CARDS',
  PERSONAL_LOANS: 'PERSONAL_LOANS',
  STUDENT_LOANS: 'STUDENT_LOANS',
  MORTGAGES: 'MORTGAGES',
  INVESTMENT_ACCOUNTS: 'INVESTMENT_ACCOUNTS'
};
export var ProviderErrorResolutionActions = {
  GO_TO_SITE: 'GOTO_SITE',
  LOGIN: 'LOGIN',
  REFRESH: 'REFRESH',
  TRY_OTHER_PROVIDER: 'TRY_OTHER_PROVIDER'
};
export var NWFinancialAccountTypes = {
  CHECKING: 'CHECKING',
  SAVINGS: 'SAVINGS',
  INVESTMENT: 'INVESTMENT',
  RETIREMENT: 'RETIREMENT',
  OTHER: 'OTHER'
};
export var YodleeAccountTypes = {
  BANK: 'bank',
  BILL: 'bill',
  CREDIT_CARD: 'creditCard',
  INSURANCE: 'insurance',
  // 1/9/2018 not supported by the backend yet, use with discretion
  INVESTMENT: 'investment',
  LOAN: 'loan',
  REWARD: 'reward'
};
export var YodleeAccountTypeMappings = (_YodleeAccountTypeMap = {}, _defineProperty(_YodleeAccountTypeMap, YodleeAccountTypes.BANK, ProviderType.BANKING), _defineProperty(_YodleeAccountTypeMap, YodleeAccountTypes.CREDIT_CARD, ProviderType.CREDIT_CARDS), _defineProperty(_YodleeAccountTypeMap, YodleeAccountTypes.INVESTMENT, ProviderType.INVESTMENT_ACCOUNTS), _defineProperty(_YodleeAccountTypeMap, YodleeAccountTypes.LOAN, ProviderType.PERSONAL_LOANS), _YodleeAccountTypeMap); // The properties as they're named on the backend models

export var YodleeAccountSubTypePropertyName = (_YodleeAccountSubType = {}, _defineProperty(_YodleeAccountSubType, YodleeAccountTypes.BANK, 'bank_account_type'), _defineProperty(_YodleeAccountSubType, YodleeAccountTypes.CREDIT_CARD, 'credit_account_type'), _defineProperty(_YodleeAccountSubType, YodleeAccountTypes.LOAN, 'loan_account_type'), _YodleeAccountSubType); // See https://developer.yodlee.com/Yodlee_API/Account_Type for more

export var YodleeAccountSubTypes = {
  AUTO_LOAN: 'AUTO_LOAN',
  CHECKING: 'CHECKING',
  CREDIT: 'CREDIT',
  MORTGAGE: 'MORTGAGE',
  PERSONAL_LOAN: 'PERSONAL_LOAN',
  SAVINGS: 'SAVINGS',
  STUDENT_LOAN: 'STUDENT_LOAN',
  MONEY_MARKET: 'MONEY_MARKET'
};
export var YodleeAccountTypesWithTransactions = [YodleeAccountTypes.BANK, YodleeAccountTypes.CREDIT_CARD, YodleeAccountTypes.INVESTMENT];
/**
 * @deprecated Use {@link TransactionCategoriesV2} instead.
 */

export var TransactionCategories = {
  BILL: 'bill',
  FEES: 'fees',
  FOOD: 'food',
  INCOME: 'income',
  OMIT: 'omit',
  OTHER: 'other',
  TRANSPORT: 'transport'
};
export var TransactionCategoriesV2 = {
  CHILDCARE: 'CHILDCARE',
  DONATIONS: 'DONATIONS',
  ENTERTAINMENT: 'ENTERTAINMENT',
  FEES: 'FEES',
  GROCERIES: 'GROCERIES',
  HEALTH: 'HEALTH',
  HOUSING: 'HOUSING',
  INCOME: 'INCOME',
  INSURANCE: 'INSURANCE',
  OTHER: 'OTHER',
  PETS: 'PETS',
  RESTAURANTS: 'RESTAURANTS',
  SHOPPING: 'SHOPPING',
  SUBSCRIPTIONS: 'SUBSCRIPTIONS',
  TRANSFERS: 'TRANSFERS',
  TRANSPORT: 'TRANSPORT',
  TRAVEL: 'TRAVEL',
  UTILITIES: 'UTILITIES'
};
export var MANUAL_TRANSACTION_DESCRIPTION = 'MANUALLY_ADDED';
export var EverythingElseCategoryKey = 'EVERYTHING_ELSE';
export var DefaultTopProviders = (_DefaultTopProviders = {
  DEFAULT: [{
    name: 'Chase',
    id: 643,
    logos: {
      primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/chase.png'
    }
  }, {
    name: 'Wells Fargo',
    id: 5,
    logos: {
      primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/wells_fargo.png'
    }
  }, {
    name: 'Bank of America',
    id: 2852,
    logos: {
      primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/bofa.png'
    }
  }, {
    name: 'Discover',
    id: 11,
    logos: {
      primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/discover.png'
    }
  }, {
    name: 'American Express',
    id: 12,
    logos: {
      primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/amex.png'
    }
  }, {
    name: 'Citibank',
    id: 1603,
    logos: {
      primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/citibank.png'
    }
  }, {
    name: 'US Bank',
    id: 524,
    logos: {
      primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/us_bank.png'
    }
  }, {
    name: 'USAA',
    id: 3278,
    logos: {
      primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/usaa.png'
    }
  }, {
    name: 'PNC Bank',
    id: 2162,
    logos: {
      primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/pnc.png'
    }
  }, {
    name: 'Navy Federal',
    id: 3357,
    logos: {
      primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/navy_federal.png'
    }
  }]
}, _defineProperty(_DefaultTopProviders, ProviderType.CREDIT_CARDS, [{
  name: 'Capital One',
  id: 3646,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/capital_one.png'
  }
}, {
  name: 'Chase',
  id: 643,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/chase.png'
  }
}, {
  name: 'Discover Card',
  id: 11,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/discover.png'
  }
}, {
  name: 'Citibank',
  id: 1603,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/citibank.png'
  }
}, {
  name: 'American Express',
  id: 12,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/amex.png'
  }
}, {
  name: 'Bank of America',
  id: 2852,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/bofa.png'
  }
}, {
  name: 'Wells Fargo',
  id: 5,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/wells_fargo.png'
  }
}, {
  name: 'US Bank',
  id: 524,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/us_bank.png'
  }
}]), _defineProperty(_DefaultTopProviders, ProviderType.BANKING, [{
  name: 'Chase',
  id: 643,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/chase.png'
  }
}, {
  name: 'Bank of America',
  id: 2852,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/bofa.png'
  }
}, {
  name: 'Wells Fargo',
  id: 5,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/wells_fargo.png'
  }
}, {
  name: 'Citibank',
  id: 1603,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/citibank.png'
  }
}, {
  name: 'Capital One',
  id: 3646,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/capital_one.png'
  }
}, {
  name: 'US Bank',
  id: 524,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/us_bank.png'
  }
}, {
  name: 'USAA',
  id: 3278,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/usaa.png'
  }
}, {
  name: 'PNC Bank',
  id: 2162,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/pnc.png'
  }
}, {
  name: 'Navy Federal',
  id: 3357,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/navy_federal.png'
  }
}, {
  name: 'TD Bank',
  id: 4132,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/td_bank.png'
  }
}]), _defineProperty(_DefaultTopProviders, ProviderType.PERSONAL_LOANS, [{
  name: 'Lending Club',
  id: 12171,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/lending_club.png'
  }
}, {
  name: 'SoFi',
  id: 21576,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/sofi.png'
  }
}, {
  name: 'Upstart',
  id: 20509,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/upstart.png'
  }
}, {
  name: 'OneMain',
  id: 15146,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/one-main.png'
  }
}, {
  name: 'Discover Personal Loans',
  id: 13141,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/discover-financial.png'
  }
}, {
  name: 'Prosper',
  id: 9749,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/prosper.png'
  }
}, {
  name: 'Lightstream',
  id: 12944,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/lightstream.png'
  }
}, {
  name: 'Avant',
  id: 20099,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/avant.png'
  }
}]), _defineProperty(_DefaultTopProviders, ProviderType.STUDENT_LOANS, [{
  name: 'Navient',
  id: 19632,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/navient.png'
  }
}, {
  name: 'Nelnet',
  id: 7616,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/nelnet.png'
  }
}, {
  name: 'Great Lakes',
  id: 4391,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/great_lakes.png'
  }
}, {
  name: 'FedLoan Servicing',
  id: 14229,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/great_lakes.png'
  }
}, {
  name: 'Sallie Mae',
  id: 3589,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/great_lakes.png'
  }
}, {
  name: 'Mohela',
  id: 12984,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/mohela.png'
  }
}, {
  name: 'EdFinancial',
  id: 16439,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/edfinancial.png'
  }
}, {
  name: 'AES',
  id: 9877,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/usaa.png'
  }
}]), _defineProperty(_DefaultTopProviders, ProviderType.MORTGAGES, [{
  name: 'Quicken Loans',
  id: 15730,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/quicken_loans.png'
  }
}, {
  name: 'Wells Fargo',
  id: 5,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/wells_fargo.png'
  }
}, {
  name: 'Chase',
  id: 643,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/chase.png'
  }
}, {
  name: 'Bank of America',
  id: 2852,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/bofa.png'
  }
}, {
  name: 'Citi Mortgage',
  id: 3584,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/citi_mortgage.png'
  }
}, {
  name: 'US Bank',
  id: 524,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/citi_mortgage.png'
  }
}, {
  name: 'Freedom Mortgage Corporation',
  id: 9640,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/flagstar_bancorp.png'
  }
}, {
  name: 'Loan Depot',
  id: 17654,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/citi_mortgage.png'
  }
}]), _defineProperty(_DefaultTopProviders, ProviderType.INVESTMENT_ACCOUNTS, [{
  name: 'Fidelity Investments',
  id: 492,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/fidelity.png'
  }
}, {
  name: 'Vanguard',
  id: 98,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/vanguard.png'
  }
}, {
  name: 'Charles Schwab',
  id: 21,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/charles_schwab.png'
  }
}, {
  name: 'Bank of America',
  id: 2852,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/bofa.png'
  }
}, {
  name: 'Betterment',
  id: 16107,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/betterment.png'
  }
}, {
  name: 'Wealthfront',
  id: 17647,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/wealthfront.png'
  }
}, {
  name: 'TD Ameritrade Inc.',
  id: 291,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/td_ameritrade.png'
  }
}, {
  name: 'E*TRADE',
  id: 744,
  logos: {
    primary: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/etrade.png'
  }
}]), _DefaultTopProviders);
export var YodleeStepSlugs = {
  SEARCH: 'provider-search',
  LOGIN: 'provider-login',
  MFA: 'provider-mfa',
  ERROR: 'provider-error',
  SUCCESS: 'provider-success',
  LINKING: 'provider-linking'
};
export var YodleeBankAccountType = {
  SAVINGS: 'SAVINGS'
};
export var TransactionFilters = ['category', 'accountId', 'merchantName', 'tag', 'include_nw_disabled'];
export var CustomProviderIcons = {
  AMERICAN_EXPRESS: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/amex-icon@2x.png',
  AVANT: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/avant-icon@2x.png',
  BANK_OF_AMERICA: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/bofa-icon@2x.png',
  BETTERMENT: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/betterment@2x.png',
  CAPITAL_ONE: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/capital_one-icon@2x.png',
  CHARLES_SCHWAB: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/charles_schwab-icon@2x.png',
  CHASE: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/chase-icon@2x.png',
  CITIBANK: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/citibank-icon@2x.png',
  DISCOVER: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/discover-icon@2x.png',
  ETRADE: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/etrade@2x.png',
  FIDELITY: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/fidelity-icon@2x.png',
  FIDELITY_NETBENEFITS: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/fidelity_netbenefits-icon@2x.png',
  FLAGSTAR: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/flagstar_bancorp-icon@2x.png',
  GREAT_LAKES: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/great_lakes-icon@2x.png',
  HSBC: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/hsbc-icon@2x.png',
  LENDING_CLUB: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/lending-club-icon@2x.png',
  LIGHTSTREAM: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/lightstream-icon@2x.png',
  MARINER_FINANCE: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/mariner-finance-icon@2x.png',
  MOHELA: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/mohela-icon@2x.png',
  NAVIENT: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/navient-icon@2x.png',
  NELNET: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/nelnet-icon@2x.png',
  ONE_MAIN: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/one-main-icon@2x.png',
  PNC_BANK: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/pnc-icon@2x.png',
  PROSPER: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/prosper-icon@2x.png',
  QUICKEN_LOANS: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/quicken_loans-icon@2x.png',
  SOFI: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/sofi@2x.png',
  TD_BANK: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/td_bank-icon@2x.png',
  UPSTART: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/upstart-icon@2x.png',
  US_BANK: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/us_bank-icon.png',
  USAA: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/usaa-icon@2x.png',
  VANGUARD: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/vanguard-icon@2x.png',
  VSAC: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/vsac-icon@2x.png',
  WELLS_FARGO: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/wells_fargo-icon@2x.png',
  WEALTHFRONT: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/wealthfront@2x.png',
  GENERIC_BANK: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/generic-bank.png',
  GENERIC_BANK_LIGHT: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/generic-bank_light.png',
  GENERIC_CREDIT: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/generic-credit.png',
  GENERIC_INVESTMENT: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/generic-investment.png',
  GENERIC_LOAN: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/generic-loan.png'
};
export var genericIconsByYodleeAccountType = (_genericIconsByYodlee = {}, _defineProperty(_genericIconsByYodlee, YodleeAccountTypes.BANK, CustomProviderIcons.GENERIC_BANK), _defineProperty(_genericIconsByYodlee, YodleeAccountTypes.CREDIT_CARD, CustomProviderIcons.GENERIC_CREDIT), _defineProperty(_genericIconsByYodlee, YodleeAccountTypes.INVESTMENT, CustomProviderIcons.GENERIC_INVESTMENT), _defineProperty(_genericIconsByYodlee, YodleeAccountTypes.LOAN, CustomProviderIcons.GENERIC_LOAN), _genericIconsByYodlee);
export var CustomProviderIconsById = {
  12: CustomProviderIcons.AMERICAN_EXPRESS,
  17794: CustomProviderIcons.AMERICAN_EXPRESS,
  3017: CustomProviderIcons.AMERICAN_EXPRESS,
  17835: CustomProviderIcons.AMERICAN_EXPRESS,
  12526: CustomProviderIcons.AMERICAN_EXPRESS,
  20099: CustomProviderIcons.AVANT,
  2852: CustomProviderIcons.BANK_OF_AMERICA,
  17898: CustomProviderIcons.BANK_OF_AMERICA,
  12532: CustomProviderIcons.BANK_OF_AMERICA,
  16107: CustomProviderIcons.BETTERMENT,
  2856: CustomProviderIcons.CAPITAL_ONE,
  4120: CustomProviderIcons.CAPITAL_ONE,
  3646: CustomProviderIcons.CAPITAL_ONE,
  3446: CustomProviderIcons.CAPITAL_ONE,
  643: CustomProviderIcons.CHASE,
  21: CustomProviderIcons.CHARLES_SCHWAB,
  20160: CustomProviderIcons.CHARLES_SCHWAB,
  13696: CustomProviderIcons.CHARLES_SCHWAB,
  11323: CustomProviderIcons.CHARLES_SCHWAB,
  10048: CustomProviderIcons.CHARLES_SCHWAB,
  20316: CustomProviderIcons.CHARLES_SCHWAB,
  20397: CustomProviderIcons.CHARLES_SCHWAB,
  20795: CustomProviderIcons.CHARLES_SCHWAB,
  1603: CustomProviderIcons.CITIBANK,
  3584: CustomProviderIcons.CITIBANK,
  3509: CustomProviderIcons.CITIBANK,
  1503: CustomProviderIcons.CITIBANK,
  13141: CustomProviderIcons.DISCOVER,
  11: CustomProviderIcons.DISCOVER,
  10710: CustomProviderIcons.DISCOVER,
  16949: CustomProviderIcons.DISCOVER,
  744: CustomProviderIcons.ETRADE,
  11995: CustomProviderIcons.FIDELITY,
  492: CustomProviderIcons.FIDELITY,
  20853: CustomProviderIcons.FIDELITY,
  11107: CustomProviderIcons.FIDELITY,
  7110: CustomProviderIcons.FIDELITY,
  786: CustomProviderIcons.FIDELITY_NETBENEFITS,
  1327: CustomProviderIcons.FLAGSTAR,
  14469: CustomProviderIcons.FLAGSTAR,
  19009: CustomProviderIcons.FLAGSTAR,
  4391: CustomProviderIcons.GREAT_LAKES,
  10336: CustomProviderIcons.GREAT_LAKES,
  3612: CustomProviderIcons.HSBC,
  17907: CustomProviderIcons.HSBC,
  10722: CustomProviderIcons.HSBC,
  10725: CustomProviderIcons.HSBC,
  13543: CustomProviderIcons.HSBC,
  19686: CustomProviderIcons.HSBC,
  20280: CustomProviderIcons.HSBC,
  4054: CustomProviderIcons.HSBC,
  12171: CustomProviderIcons.LENDING_CLUB,
  12944: CustomProviderIcons.LIGHTSTREAM,
  18661: CustomProviderIcons.MARINER_FINANCE,
  12984: CustomProviderIcons.MOHELA,
  19632: CustomProviderIcons.NAVIENT,
  7616: CustomProviderIcons.NAVIENT,
  15146: CustomProviderIcons.ONE_MAIN,
  2162: CustomProviderIcons.PNC_BANK,
  9749: CustomProviderIcons.PROSPER,
  15730: CustomProviderIcons.QUICKEN_LOANS,
  21576: CustomProviderIcons.SOFI,
  4132: CustomProviderIcons.TD_BANK,
  291: CustomProviderIcons.TD_BANK,
  15767: CustomProviderIcons.TD_BANK,
  15396: CustomProviderIcons.TD_BANK,
  12659: CustomProviderIcons.TD_BANK,
  20073: CustomProviderIcons.TD_BANK,
  20509: CustomProviderIcons.UPSTART,
  3278: CustomProviderIcons.USAA,
  7056: CustomProviderIcons.USAA,
  17: CustomProviderIcons.US_BANK,
  524: CustomProviderIcons.US_BANK,
  98: CustomProviderIcons.VANGUARD,
  18972: CustomProviderIcons.VANGUARD,
  21080: CustomProviderIcons.VANGUARD,
  21084: CustomProviderIcons.VANGUARD,
  17785: CustomProviderIcons.VSAC,
  17647: CustomProviderIcons.WEALTHFRONT,
  5: CustomProviderIcons.WELLS_FARGO,
  12178: CustomProviderIcons.WELLS_FARGO,
  8826: CustomProviderIcons.WELLS_FARGO,
  4891: CustomProviderIcons.WELLS_FARGO,
  10527: CustomProviderIcons.WELLS_FARGO
};
export var CashFlowCategories = {
  SPENDING: 'spending',
  EARNING: 'earning'
};
export var TOP_MERCHANTS_REQUEST_LIMIT = 20;
export var ProviderAccountErrorPriorities = {
  HIGH_PRIORITY: 'HIGH_PRIORITY',
  NORMAL_PRIORITY: 'NORMAL_PRIORITY',
  MUTED_ERROR: 'MUTED_ERROR'
}; // from https://nerdwallet.atlassian.net/wiki/spaces/ENG/pages/667189493/FDP+Instrumentation+and+Forensics#FDPInstrumentationandForensics-POST/financial_portals/proxy/event

export var FdpLinkEvent = {
  AUTHENTICATION_SUCCESS: 'AUTHENTICATION_SUCCESS',
  EXIT: 'EXIT',
  FLOW_CLOSED: 'FLOW_CLOSED',
  FLOW_OPENED: 'FLOW_OPENED',
  INSTITUTION_SEARCHED: 'INSTITUTION_SEARCHED',
  SOURCE_EVENT: 'SOURCE_EVENT'
};
export var UserPreferredIncomeEstimateSources = {
  PROJECTED: 'PROJECTED',
  USER_REPORTED: 'USER_REPORTED'
};
export var AccountAggregationAction = {
  CLOSE_FLOW: {
    label: 'OK, got it',
    type: 'close_flow'
  },
  CONTACT_US: {
    label: 'Contact us',
    type: 'contact_us'
  },
  GO_TO_BANK: {
    label: "Go to bank's website",
    type: 'go_to_bank'
  },
  RELINK: {
    label: 'Relink account',
    type: 'relink'
  },
  REVIEW_ACCOUNT_LIST: {
    label: 'Review account list',
    type: 'review_account_list'
  },
  TRY_ANOTHER_INSTITUTION: {
    label: 'Relink account',
    type: 'try_another_institution'
  },
  UNLINK: {
    label: 'Unlink account',
    type: 'unlink'
  }
};
export var AccountAggregationActionType = _reduce(AccountAggregationAction, function (types, action) {
  var actionType = action.type.toUpperCase(); // eslint-disable-next-line no-param-reassign

  types[actionType] = action.type;
  return types;
}, {});
export var YodleeSearchFallback = {
  ANOTHER_WAY: 'ANOTHER_WAY',
  // falls back to Yodlee search with a "link another way" transition screen
  DEFAULT: 'DEFAULT',
  // falls back to Yodlee search with no transition screen
  NONE: null // does not fall back to Yodlee search

};